'use strict';

angular.module('app')
  .directive('paymentMethodsList', function (paymentService, $location, info, $timeout) {
    var controller = function ($scope) {
      var vm = this;
      vm.cardFormVisible = false;
      $scope.initPaymentMethod = initPaymentMethod;
      vm.submitSEPA = submitSEPA;
      vm.submitCard = submitCard;
      vm.submitRedirectForm = submitRedirectForm;
      vm.setCreditCardForm = setCreditCardForm;
      vm.paymentMethodsList = info.payments.EXTERNAL_PAYMENT_METHOD_TYPES;
      vm.saveRedirectPreferrence = saveRedirectPreferrence;
      // vm.success = $scope.success;

      if (vm.isCheckout && vm.hideSepa) {
        // hide SEPA on checkout;
        var sepaIndex = _.findIndex(vm.paymentMethodsList, { 'value': 'sepa_debit'});
        vm.paymentMethodsList.splice(sepaIndex, 1);
      }

      if (vm.hideRedirect) {
        _.remove(vm.paymentMethodsList, function (pm) {
          return pm.flow === 'redirect';
        });
      }

      // pre-initialize payment method if it was passed outside
      if (vm.selectedMethod) {
        var preselected = _.find(vm.paymentMethodsList, { 'value': vm.selectedMethod});
        if (preselected) {
          $timeout(function () {
            initPaymentMethod(preselected);
          }, 1000);
        }
      }

      // pre-populate user namefrom order for redirect methods
      if (vm.redirectPaymentsData) {
        vm.redirectName = vm.redirectPaymentsData.fullName;
      }

      function initPaymentMethod(paymentMethod) {
        vm.selectedPaymentMethod = _.clone(paymentMethod);

        // outer variable
        vm.selectedMethod = paymentMethod.value;
        if (paymentMethod.flow === 'card') {
          // credit cards;
          var contId = '#paymentMethodContainer-' + paymentMethod.value;
          $('#cardForm').appendTo(contId);
          vm.cardFormVisible = true;

          if (vm.paymentProcessor === 10) {
            paymentService.createPaymentForm();
          } else if (vm.paymentProcessor === 70) {
            paymentService.createAdyenCardForm();
          }
          vm.currencyToCharge = vm.nextPayment && vm.nextPayment.currency;
        } else if (paymentMethod.flow === 'sepa') {
          // sepa
          paymentService.createIbanForm();
          vm.currencyToCharge = 'EUR';
        } else if (paymentMethod.flow === 'redirect') {
          if (paymentMethod.value === 'ideal' && !vm.isCheckout) {
            paymentService.createIdealForm();
          }
          vm.currencyToCharge = 'EUR';
        }
      }

      function submitSEPA(form) {
        form.$submitted = true;

        if (form.$valid && !vm.loader) {
          vm.loader = true;
          var ibanData = {name: vm.ibanName, email: vm.ibanEmail};

          paymentService.createSourceFromIban(ibanData, function (response) {
            $scope.$apply(function () {
              vm.loader = false;
            });
            if (!response.error) {
              $scope.$apply(function () {
                vm.success = true;
              });
            }
            performCallback(response);
          }).catch(function () {
            vm.loader = false;
          });
        } else {
          returnError('Invalid payment form');
        }
      }

      function submitCard(form) {
        form.$submitted = true;
        var paymentData = {};

        if (form.$valid && !vm.loader) {
          // STRIPE
          vm.loader = true;
          if (vm.paymentProcessor === 10) {
            paymentService.createSource(function (response) {
              $scope.$apply(function () {
                vm.loader = false;
              });
              if (!response.error) {
                $scope.$apply(function () {
                  vm.success = true;
                });
              }
              performCallback(response);
            }).catch(function () {
              vm.loader = false;
            });
            // ADYEN
          } else if (vm.paymentProcessor === 70) {
            paymentData = paymentService.getAdyenPaymentData();
            if (paymentData) {
              performCallback(paymentData);
              vm.success = true;
            }
            vm.loader = false;
            returnError('Card information is not complete');
          }
        } else {
          returnError('Invalid payment form');
        }
      }

      function submitRedirectForm(form) {
        form.$submitted = true;
        var returnUrl = $location.absUrl().split('?')[0] + '?paymentComplete=true';

        if (form.$valid && !vm.loader) {
          vm.loader = true;
          var redirectData = {
            name: vm.redirectName,
            amount: vm.redirectPaymentsData.amountToCharge,
            statementDescriptor: vm.redirectPaymentsData.statementDescriptor,
            returnUrl: returnUrl,
            redirectType: vm.selectedPaymentMethod.value,
          };

          paymentService.createRedirectSource(redirectData, function (response) {
            $scope.$apply(function () {
              vm.loader = false;
            });
            if (!response.error) {
              $scope.$apply(function () {
                vm.success = true;
              });
            }
            performCallback(response);
          }).catch(function () {
            vm.loader = false;
          });
        } else {
          returnError('Invalid form');
        }
      }

      function returnError(text) {
        var response = {};
        if (typeof vm.callbackFn === 'function') {
          response.error = {};
          response.error.message = text;
          vm.callbackFn(response);
        }
        return false;
      }

      function setCreditCardForm(form) {
        vm.cardForm = form;
      }

      function performCallback(data) {
        if (typeof vm.callbackFn === 'function') vm.callbackFn(data);
      }

      function saveRedirectPreferrence() {
        performCallback({isRedirect: true, paymentMethodValue: vm.selectedPaymentMethod.value});
      }

      $scope.$on('createSource', function (event) {
        if (!vm.selectedPaymentMethod) {
          performCallback({noMethod: true});
          return;
        }

        if (vm.selectedPaymentMethod.flow === 'card') {
          submitCard(vm.cardForm);
        } else if (vm.selectedPaymentMethod.flow === 'sepa') {
          submitSEPA($scope.ibanForm);
        } else if (vm.selectedPaymentMethod.flow === 'redirect') {
          saveRedirectPreferrence();
        } else {
          return;
        }
      });
    };

    return {
      restrict: 'A',
      templateUrl: window.templatePath ? window.templatePath + 'templates/_payment-methods-list.html' : '../templates/_payment-methods-list.html',
      controller: controller,
      controllerAs: 'ctrl',
      bindToController: true,
      scope: {
        callbackFn: '=',
        success: '=',
        successMessage: '@',
        buttonText: '@',
        hideSubmit: '=',
        hideSepa: '=',
        hideRedirect: '=',
        selectedMethod: '=',
        paymentProcessor: '=',
        isCheckout: '=',
        isUnconfirmedOrder: '=',
        redirectPaymentsData: '=',
        nextPayment: '=',
        currencyToCharge: '=',
      },
    };
  });
